import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c('div',{staticClass:"iframe-container"},[_c('iframe',{ref:"gameIframe",staticClass:"game-iframe",attrs:{"src":_vm.iframeSrc}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }